"use strict";
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ WHICH SURFACE A DRILL-IN OPENS IN — item 34's rules, in one place.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The tester feedback of 9 Sep 2026 states them as a ladder:
 *
 * | opened from        | opens as     |
 * | ------------------ | ------------ |
 * | a list (no overlay)| **modal**    |
 * | a modal            | **full page**|
 * | a full page        | **drawer**   |
 * | a drawer           | **drawer**   |
 *
 * ⚠️⚠️ **EVERY DRILL-IN IN THIS PRODUCT OPENED AS A DRAWER BEFORE THIS, AND THAT IS THE
 * COMPLAINT.** `contracts-route.tsx`, `tasks-route.tsx`, `delivery-route.tsx` and
 * `dashboard-route.tsx` each held `useState<Mode>('drawer')` and each hardcoded `'drawer'` again
 * at the nested call sites — so a line item opened from a contract drawer produced two drawers,
 * two backdrops and a 560px column inside a 720px one.
 *
 * ⚠️⚠️ **A FUNCTION, NOT A CONTEXT, AND THE STATE IS WHY.** The mode of a nested detail lives in
 * the ROUTE — it has to, because a deep link opens straight into one — and the route already
 * holds the mode of the surface the drill-in came from. So the answer is one call at the click,
 * against a value already in hand. A React context would need every surface to publish its kind
 * and every handler to read it through a hook it cannot call conditionally, for the same answer.
 *
 * ⚠️ **The ladder does not loop.** A drawer opening a drawer is where it stops, deliberately:
 * that is the one nesting a person actually does repeatedly — task to related task to its
 * project — and escalating it would throw away the surface they were reading.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextSurface = nextSurface;
function nextSurface(from) {
    if (from === 'page')
        return 'modal';
    /**
     * ⚠️⚠️ **A MODAL ESCALATES TO THE FULL PAGE, WHICH NAVIGATES AWAY FROM THE MODAL.** That is the
     * rule as written and it is the one consequence worth stating out loud: drilling in from a modal
     * does not stack a second surface, it commits to the page. A modal is the shallow surface — it
     * has no room for a detail beside its own content — so the choice is between replacing it and
     * compounding it, and the feedback asks for the first.
     */
    if (from === 'modal')
        return 'full';
    /* A full page has the whole screen, so a detail over it is a drawer beside what it came from. */
    if (from === 'full')
        return 'drawer';
    return 'drawer';
}
//# sourceMappingURL=surface.js.map